import type { SVGProps } from 'react';

const SvgBenchmarks = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M11.86 13.17V29.7H4.93V3.17A1.35 1.35 0 0 1 6.4 2h10.74a1.35 1.35 0 0 1 1.47 1.18V9h1.5V3.17a2.84 2.84 0 0 0-3-2.68H6.4a2.84 2.84 0 0 0-3 2.68V29.7H.84v1.5h30.29v-1.5h-2.59V13.17a2.83 2.83 0 0 0-3-2.68H14.83a2.84 2.84 0 0 0-2.97 2.68Zm15.18 0V29.7H13.36V13.17A1.35 1.35 0 0 1 14.83 12h10.75A1.35 1.35 0 0 1 27 13.17Z"
      data-name="benchmarks"
    />
  </svg>
);

export default SvgBenchmarks;
